import { Injectable } from '@angular/core';
import { HttpFunctionsService } from '../http-services/http-functions.service';
import { BehaviorSubject, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { BillingListModel } from 'src/app/models/billing-address.model';

@Injectable({
  providedIn: 'root'
})
export class BillingAddressService {

  billingUrl: string = 'billing-address/';
  constructor(private httpService: HttpFunctionsService) { }

  /**
   * get billing address list
   * @param billingAddressId string
   * @returns 
   */
  getBillingAddress(billingAddressId:string = '') {
    const sendData = {
      "billing_address_id": billingAddressId
    }
    return this.httpService.postMethod(this.billingUrl+'list',sendData,true).pipe( map( (res:any) => {
      let billingList : Array<BillingListModel> = [];
      if (res.data) {
        billingList =res.data.filter((item: BillingListModel) => {
            item.isSelected = false;
            return item;
        });
      }
      return billingList;
    }), catchError(error => {
      return throwError(error);
    }));
  }

  /**
   * Insert Billing address
   * @param sendData 
   * @returns 
   */
  insertBillingAddress(sendData:any) {
    return this.httpService.postMethod(this.billingUrl+'insert',sendData,true);
  }

   /**
   * Insert Billing address
   * @param sendData 
   * @returns 
   */
   updateBillingAddress(sendData:any, currentBillingId: string) {
    return this.httpService.patchMethod(this.billingUrl+'insert',sendData,true);
  }


  /**
   * delete billing address
   * @param addressId 
   * @returns 
   */
  deleteBillingAddress(addressId:any) {
    const baseUrl = this.billingUrl + addressId +"/delete";
    return this.httpService.deleteMethod(baseUrl);
  }
}
